function changeAmount(amount) {
  const input_boxes = document
    .querySelectorAll(".count-input")
    .forEach((input_box) => {
      let currentValue = parseInt(input_box.value, 10);
      if (isNaN(currentValue) || currentValue < 1) {
        currentValue = 1;
      }
      currentValue += amount;
      if (currentValue < 1) {
        currentValue = 1;
      }
      input_box.value = currentValue;
    });
}

// icons container show hide
const iconCont1 = document.querySelector(".icon-container.cont-1");
const iconCont2 = document.querySelector(".icon-container.cont-2");
const iconCont3 = document.querySelector(".icon-container.cont-3");

const box1 = document.querySelector(".hover-box.box-1");
const box2 = document.querySelector(".hover-box.box-2");
const box3 = document.querySelector(".hover-box.box-3");

const iconContainers = document.querySelectorAll(".icon-container");
const boxes = document.querySelectorAll(".hover-box");

iconContainers?.forEach((container, index) => {
  const box = boxes[index];
  container.addEventListener("mouseenter", () => {
    box?.classList.add("show");
  });
  container.addEventListener("mouseleave", () => {
    box?.classList.remove("show");
  });
  box?.addEventListener("mouseenter", () => {
    box?.classList.add("show");
  });
  box?.addEventListener("mouseleave", () => {
    box?.classList.remove("show");
  });
});

//swiper js
document.addEventListener("DOMContentLoaded", function () {
  var swiper = new Swiper(".product-swiper", {
    slidesPerView: 1,
    spaceBetween: 10,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      dynamicBullets: true,
    },
  });
});

// mobile add to cart sticky visible/hide func.
document.addEventListener("DOMContentLoaded", () => {
  const mobSticky = document.querySelector(".mobile-sticky-btn-wrapper");
  const currentViewportHeight = window.innerHeight;

  window.addEventListener("scroll", () => {
    if (window.scrollY >= currentViewportHeight) {
      mobSticky.style.transform = "translateY(0)";
      mobSticky.style.opacity = 1;
    } else {
      mobSticky.style.transform = "translateY(100%)";
      mobSticky.style.opacity = 0;
    }
  });
});
